import { ScriptProcessorContainer, ScriptProcessible, ScriptRequest, ScriptResult, ScriptResultFailed } from "documaker.scripting";
import { ExecuteRequest, ExternalScriptExecuteResult, ScriptLinkItem } from "../../../../domain/localhost/items";
import { IInternalScriptProcessible } from "..";

// DocuMaker Cloudでも使ってるdocumaker.scriptingを利用するラッパーコンテナ.利用側でprocessorを詰めて利用する想定.
export class WrapperContainer implements IInternalScriptProcessible {
  constructor(...processors: ScriptProcessible[]) {
    this._container = new ScriptProcessorContainer(...processors);
  }

  private readonly _container: ScriptProcessible;

  isProcessible(request: ExecuteRequest): boolean {
    return this._container.isProcessible(this.toScriptRequest(request));
  }

  async process(request: ExecuteRequest): Promise<ExternalScriptExecuteResult> {
    return this.fromScriptResult(await this._container.process(this.toScriptRequest(request)));
  }

  private fromScriptResult(source: ScriptResult): ExternalScriptExecuteResult {
    const result = new ExternalScriptExecuteResult();
    if (source.isOk) {
      result.isComplete = true;
      result.isCancel = false;
      result.name = source.name;
      result.values = source.values.map(v => ({
        row: v.row,
        column: v.column,
        value: v.value,
      }));
      result.compressedCsvText = source.compressedCsvText;
      result.scriptLinkResults = source.results.map(r => {
        const item = new ScriptLinkItem();
        item.name = r.referer.key;
        item.objectId = r.referer.objId;
        item.subName = r.referer.subkey;
        item.itemName = r.referer.type;
        item.value = r.value;
        return item;
      });
    } else {
      // なぜか型推論が効かない.TypeScriptが古い？
      result.isComplete = false;
      result.isCancel = (source as ScriptResultFailed).isCancelled;
    }
    return result;
  }

  private toScriptRequest(source: ExecuteRequest): ScriptRequest {
    return {
      exePath: source.exePath,
      csvPath: source.csvPath,
      split: source.splitter,
      row: 0,     // DocuMaker3ではない.外部データ用だから？
      column: 0,  // DocuMaker3ではない.外部データ用だから？
      beforeValuePath: source.csvBeforeValuePath,
      valuePath: source.csvInputValuePath,
      patientNo: source.patientId,
      arguments: source.arguments,
      references: source.scriptLinkItems.map(i => ({
        referer: {
          type: i.itemName,
          key: i.name,
          objId: i.objectId,
          subkey: i.subName,
        },
        value: i.value,
      }))
    };
  }
}
